






























import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ApolloClient, { serverBase } from "../apollo";
import gql from "graphql-tag";
import studioFragment from "../fragments/studio";

@Component
export default class StudioSelector extends Vue {
  @Prop() value!: any;
  @Prop({ default: false }) multiple!: boolean;
  @Prop({ default: null }) ignore!: string; // Ignores studio ID in search results

  innerValue = this.value ? JSON.parse(JSON.stringify(this.value)) : null;

  studios: any[] = this.value ? [this.value] : [];
  searchQuery = "";

  loading = false;
  resetTimeout = null as NodeJS.Timeout | null;

  @Watch("value", { deep: true })
  onValueChange(newVal: any) {
    this.innerValue = newVal;
  }

  onInnerValueChange(newVal: string) {
    this.$emit(
      "input",
      this.studios.find((a) => a._id == newVal)
    );
  }

  thumbnail(scene: any) {
    if (scene.thumbnail)
      return `${serverBase}/media/image/${scene.thumbnail._id}?password=${localStorage.getItem(
        "password"
      )}`;
    return "";
  }

  @Watch("searchQuery")
  onSearch(newVal: string | null) {
    if (this.resetTimeout) {
      clearTimeout(this.resetTimeout);
    }
    if (!this.searchQuery) return;

    this.resetTimeout = setTimeout(() => {
      this.loading = true;
      this.fetchPage(this.searchQuery);
    }, 500);
  }

  async fetchPage(searchQuery: string) {
    try {
      const result = await ApolloClient.query({
        query: gql`
          query($query: StudioSearchQuery!) {
            getStudios(query: $query) {
              items {
                ...StudioFragment
              }
            }
          }
          ${studioFragment}
        `,
        variables: {
          query: {
            query: searchQuery || "",
          },
        },
      });

      this.loading = false;
      this.studios.push(...result.data.getStudios.items);

      let ids = [...new Set(this.studios.map((a) => a._id))];

      if (this.ignore !== null) {
        ids = ids.filter((id) => id != this.ignore);
      }

      this.studios = ids
        .map((id) => this.studios.find((a) => a._id == id))
        .filter(Boolean) as any[];
    } catch (err) {
      throw err;
    }
  }
}
